import React, { useMemo } from 'react';
import { Settings } from 'react-slick';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const useSliderSettings = () => {
  const settings: Settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      // animation speed
      speed: 2500,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: true,
      // speed between slides on autoplay
      autoplaySpeed: 6000,
      cssEase: 'ease',
      pauseOnHover: false,
      // dot styling
      customPaging: () => <Box className="custom-dot" width={{ _: pxToRem(20), xs: 8, sm2: pxToRem(46) }} height={1} borderRadius="full" backgroundColor="white" />
    }),
    []
  );

  return { settings };
};
